<template>
  <span v-html="title"></span>
</template>

<script>
  export default {
    name: 'HighlightText',
    props: {
      item: {
        type: Object,
        required: true
      }
    },
    computed: {
      title () {
        const item = highlight(this.item)
        // TODO: escape this?
        return item.name || item.title
      }
    }
  }

  function highlight (result, highlightClassName = 'strong') {
    const set = (obj, path, value) => {
      const pathValue = path.split('.')
      let i

      for (i = 0; i < pathValue.length - 1; i++) {
        obj = obj[pathValue[i]]
      }

      obj[pathValue[i]] = value
    }

    const generateHighlightedText = (inputText, regions = []) => {
      let content = ''
      let nextUnhighlightedRegionStartingIndex = 0

      regions.forEach((region) => {
        const lastRegionNextIndex = region[1] + 1

        content += [
          inputText.substring(nextUnhighlightedRegionStartingIndex, region[0]),
          `<span class="${ highlightClassName }">`,
          inputText.substring(region[0], lastRegionNextIndex),
          '</span>',
        ].join('')

        nextUnhighlightedRegionStartingIndex = lastRegionNextIndex
      })

      content += inputText.substring(nextUnhighlightedRegionStartingIndex)

      return content
    }

    const { item, matches } = result

    const highlightedItem = { ...item }

    matches.forEach((match) => {
      set(highlightedItem, match.key, generateHighlightedText(match.value, match.indices))
    })

    return highlightedItem
  }
</script>
